const deepForEach = require('./deep-for-each')

/*
 * gathers all values from a deep structure and returns them flat
 * in an array, see deepForEach for a more in depth explanation
 *
 * deepValues({ a: 'foo', b: { c: 'bar', d: 'baz' } }) -> [ 'foo', 'bar', 'baz' ]
 */

function deepValues (structure) {
  const values = []

  deepForEach(
    structure,
    function (value) { values.push(value) }
  )

  return values
}

module.exports = deepValues
